import { getTranslation } from './languageUtils'

export const formatMoney = (money?: number) => {
  if (!money && money !== 0) return
  return `${(money ?? 0).toLocaleString('ru')} ${getTranslation('general.currency')}`
}
